export default {plugin:{algolia:{ui:{search_by:'搜索提供'}}}};